import GradePage from "@/pages/GradePage";
export default function GradeGrade7() {
  return <GradePage grade="7" />;
}
